<template>
	<div class="drv-search-bar">
		<b-form-group class="mb-0">
			<b-input-group class="input-group-alternative input-group-merge">
				<b-input-group-prepend>
					<b-input-group-text class="drv-search-bar__icon">
						<b-icon icon="search" font-scale="0.9"></b-icon>
					</b-input-group-text>
				</b-input-group-prepend>

				<b-form-input
					v-model="innerValue"
					size="sm"
					placeholder="Search"
					type="text"
					class="drv-search-bar__input"
				></b-form-input>

				<template v-if="!isSingle" #append>
					<b-dropdown
						menu-class="overflow-hidden"
						toggle-class="pl-2 pr-3"
						class="drv-search-bar__drodown border-left"
					>
						<template #button-content>
							<span class="mr-1">{{
								selectedOption
									? selectedOption.text
									: "Column Filter"
							}}</span>
						</template>

						<div class="dropdown-wrapper">
							<div class="px-3 mt-1 mb-3">
								<b-form-input
									@input="handleDropdownSearch"
									size="sm"
									class="dropdown-wrapper__search"
									placeholder="Search"
								></b-form-input>
							</div>
							<div class="dropdown-wrapper__items">
								<template v-if="dropdownOptions.length">
									<b-dropdown-item
										v-for="(
											optionItem, optionIndex
										) in dropdownOptions"
										@click="searchKey = optionItem.value"
										:key="`field-${optionIndex}`"
									>
										{{ optionItem.text }}
									</b-dropdown-item>
								</template>
								<small v-else class="px-3 d-block"
									>No items found.</small
								>
							</div>
						</div>
					</b-dropdown>
				</template>
			</b-input-group>
		</b-form-group>
	</div>
</template>

<script>
import Fuse from "fuse.js";
import { debounce } from "lodash-es";

export default {
	name: "drv-search-bar",
	props: {
		value: [String, Object],
		isSingle: {
			type: Boolean,
			description:
				"Whether the field doesnt contain search keys dropdown.",
		},
		fields: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	data() {
		return {
			searchKey: null,
			dropdownSearchValue: null,
		};
	},
	computed: {
		innerValue: {
			get() {
				return this.value;
			},
			set: debounce(function (value) {
				this.$emit("input", value.trim());
			}, 1000),
		},
		dropdownOptions() {
			let dropdownOptions = this.fields
				.filter((item) => !item.isDate)
				.map((item) => {
					if ("string" === typeof item)
						return {
							text: item.replace(/_/g, " "),
							value: item,
						};
					else
						return {
							text: item.label,
							value: item.key,
						};
				});

			if (this.dropdownSearchValue) {
				const fuse = new Fuse(dropdownOptions, {
					keys: ["text"],
					useExtendedSearch: true,
				});

				dropdownOptions = fuse
					.search(`'${this.dropdownSearchValue}`)
					.map((item) => item.item);
			}

			return dropdownOptions;
		},
		selectedOption() {
			if (!this.searchKey) return null;

			const selectedIndex = this.dropdownOptions.findIndex(
				(item) => this.searchKey === item.value
			);

			return 0 <= selectedIndex
				? Object.freeze(this.dropdownOptions[selectedIndex])
				: null;
		},
	},
	methods: {
		handleDropdownSearch: debounce(function (value) {
			this.dropdownSearchValue = value;
		}, 500),
	},
	watch: {
		searchKey(newValue) {
			this.$emit("set-key", newValue);
		},
	},
};
</script>

<style lang="scss" scoped>
.dropdown-wrapper {
	&__items {
		max-height: 200px;
		overflow-y: auto;
		overflow-x: hidden;
	}

	&__search {
		border: 1px solid #dedede;
	}
}
</style>
